import { Directive, Output, EventEmitter, Renderer2, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[appClickStopPrevent]',
    standalone: false
})
export class StopPropagationDirective implements OnInit, OnDestroy {
    @Output('appClickStopPrevent') stopPropEvent = new EventEmitter();
    private unsubscribe: any;

    constructor(private renderer: Renderer2, private element: ElementRef) {
    }

    ngOnInit(): void {
        this.unsubscribe = this.renderer.listen(this.element.nativeElement, 'click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.stopPropEvent.emit(event);
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }

}
